import React, { Component } from 'react';

// Paleta consistente con los colores del template CoreUI.
const PALETTE = [
    '#20a8d8', '#4dbd74', '#f86c6b', '#f8cb00', '#6f42c1',
    '#e83e8c', '#fd7e14', '#63c2de', '#f9b115', '#2f353a',
];

// Calcula iniciales estilo "G.D" a partir de un nombre.
const getInitials = (name) => {
    if (!name) {
        return '?';
    }
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + '.' + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Elige un color determinista según el texto (mismo usuario => mismo color).
const pickColor = (seed) => {
    const value = seed || '';
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    return PALETTE[Math.abs(hash) % PALETTE.length];
};

/**
 * Avatar reutilizable: muestra la imagen del usuario si existe (y carga bien),
 * o sus iniciales como fallback.
 *
 * Props:
 *  - src:    url de la imagen (opcional)
 *  - name:   nombre completo, usado para iniciales y color (opcional)
 *  - email:  fallback para iniciales/color si no hay nombre (opcional)
 *  - size:   tamaño en px (default 40)
 *  - href:   si se pasa junto con src, envuelve la imagen en un enlace
 *  - square: bordes cuadrados en lugar de círculo (default false)
 */
class Avatar extends Component {
    state = {
        // Si la imagen no carga (404, rota) caemos a iniciales.
        failed: false,
    };

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src && this.state.failed) {
            this.setState({ failed: false });
        }
    }

    onError = () => {
        this.setState({ failed: true });
    };

    render() {
        const { src, name, email, size = 40, href, square = false, className = '', alt } = this.props;
        const label = alt || name || email || '';
        const radius = square ? '4px' : '50%';
        const showImage = src && !this.state.failed;

        if (showImage) {
            const image = (
                <img
                    src={src}
                    alt={label}
                    width={size}
                    height={size}
                    onError={this.onError}
                    className={'img-avatar ' + className}
                    style={{ width: size, height: size, objectFit: 'cover', borderRadius: radius }}
                />
            );
            if (href) {
                return <a target="_blank" rel="noopener noreferrer" href={href}>{image}</a>;
            }
            return image;
        }

        const seed = name || email;
        return (
            <span
                className={'img-avatar ' + className}
                title={label}
                style={{
                    width: size,
                    height: size,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: pickColor(seed),
                    color: '#fff',
                    fontSize: Math.round(size * 0.38),
                    fontWeight: 600,
                    lineHeight: 1,
                    borderRadius: radius,
                    textTransform: 'uppercase',
                    userSelect: 'none',
                }}
            >
                {getInitials(seed)}
            </span>
        );
    }
}

export { getInitials };
export default Avatar;



// WEBPACK FOOTER //
// ./src/Components/Common/Avatar.js